import { useEffect, useRef } from "react";
import {
    connectToNotificationHub,
    getConnectionStatus,
} from "@/services/notificationSignalR";
import logger from "@/utils/logger";

export function useNotificationSignalR(
    _applicationName: string,
    email: string,
    onNotification: (notification: unknown) => void,
    onTripStatusChanged?: (data: {
        tripId: number;
        newStatus: string;
        oldStatus: string | null;
        changedAt: string;
        changedBy?: number;
    }) => void,
    handlerName: string = "UnnamedHandler"
) {
    const lastEmailRef = useRef<string>("");
    const isMountedRef = useRef<boolean>(true);

    useEffect(() => {
        isMountedRef.current = true;

        if (!email || !email.includes("@")) {
            return;
        }

        const status = getConnectionStatus();
        if (
            lastEmailRef.current === email &&
            (status.isConnected || status.isConnecting)
        ) {
            return;
        }

        if (status.hasFailed) {
            logger.warn(
                "SignalR: Previous outage exceeded the grace threshold, retrying connection"
            );
        }

        lastEmailRef.current = email;

        let unregister: () => void = () => {};
        setTimeout(() => {
            if (isMountedRef.current) {
                unregister = connectToNotificationHub(
                    email,
                    onNotification,
                    onTripStatusChanged,
                    handlerName
                );
            }
        }, 100);

        return () => {
            lastEmailRef.current = "";
            isMountedRef.current = false;
            unregister();
        };
    }, [email, handlerName, onNotification, onTripStatusChanged]);
}
